import { IconProps } from "./IconProps";

export const ServicePackagesIcon = (props: IconProps) => {
  return (
    <svg
      width="20"
      height="21"
      className={props.className}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.0833 6.36804L9.99997 10.5M9.99997 10.5L2.91664 6.36804M9.99997 10.5L10 18.8125M17.5 14.0512V6.94878C17.5 6.64896 17.5 6.49906 17.4579 6.36536C17.4207 6.24708 17.3599 6.13851 17.2795 6.0469C17.1886 5.94336 17.0638 5.87056 16.8142 5.72496L10.6475 2.12773C10.4112 1.98987 10.293 1.92094 10.1679 1.89392C10.0571 1.87 9.94288 1.87 9.83213 1.89392C9.70698 1.92094 9.58881 1.98987 9.35248 2.12774L3.18581 5.72496C2.93621 5.87056 2.8114 5.94336 2.72053 6.04691C2.64013 6.13851 2.57929 6.24708 2.54207 6.36536C2.5 6.49906 2.5 6.64897 2.5 6.94878V14.0512C2.5 14.3511 2.5 14.501 2.54207 14.6347C2.57929 14.7529 2.64013 14.8615 2.72053 14.9531C2.8114 15.0567 2.93621 15.1295 3.18581 15.2751L9.35248 18.8723C9.58881 19.0102 9.70698 19.0791 9.83213 19.1061C9.94288 19.13 10.0571 19.13 10.1679 19.1061C10.293 19.0791 10.4112 19.0102 10.6475 18.8723L16.8142 15.2751C17.0638 15.1295 17.1886 15.0567 17.2795 14.9531C17.3599 14.8615 17.4207 14.7529 17.4579 14.6347C17.5 14.501 17.5 14.3511 17.5 14.0512Z"
        stroke="#06123D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.75 8.3125L6.25 3.9375"
        stroke="#06123D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
